var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84746 30.9847C11.6161 30.9847 14.6613 27.9531 14.6613 24.2385C14.6613 22.9559 14.308 21.9232 13.9546 20.7572L14.3584 22.1398C14.2238 21.6234 14.0556 21.0903 13.8705 20.474C13.8705 20.474 8.94104 7.78125 7.5951 7.78125C6.24917 7.78125 1.58886 20.7406 1.58886 20.7406C1.25237 21.9066 1 22.9726 1 24.2552C1 27.9698 4.04518 31.0014 7.8138 31.0014C9.21021 31.0014 10.5225 30.585 11.5992 29.852",
    stroke: "#199FAA",
    strokeWidth: 0.833323,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8847 14.5423C19.0718 14.5423 20.8552 12.7767 20.8552 10.6112C20.8552 9.86164 20.6533 9.26198 20.4514 8.57903L20.687 9.37857C20.6197 9.07874 20.5187 8.76226 20.401 8.3958C20.401 8.3958 17.524 1 16.7501 1C15.9594 1 13.2507 8.56239 13.2507 8.56239C13.0488 9.24533 12.9142 9.86164 12.9142 10.6112C12.8974 12.7767 14.6807 14.5423 16.8847 14.5423ZM16.8847 14.5423C17.6923 14.5423 18.4493 14.2924 19.0718 13.876",
    stroke: "#199FAA",
    strokeWidth: 0.833323,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2747 22.868C26.159 22.868 27.6732 21.3855 27.6732 19.5532C27.6732 18.9203 27.4881 18.4205 27.3199 17.8542L27.5218 18.5372C27.4545 18.2873 27.3703 18.0208 27.2694 17.721C27.2694 17.721 24.8131 11.5078 24.1401 11.5078C23.4671 11.5078 21.1454 17.8542 21.1454 17.8542C20.9771 18.4205 20.8594 18.9536 20.8594 19.5699C20.8594 21.3856 22.3904 22.868 24.2747 22.868ZM24.2747 22.868C24.9645 22.868 25.6206 22.6682 26.159 22.3017",
    stroke: "#199FAA",
    strokeWidth: 0.833323,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89844 23.7031C2.89844 23.7031 3.47046 28.9835 8.2317 28.9835",
    stroke: "#004B73",
    strokeWidth: 0.833323,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 10.0938C14.375 10.0938 14.6778 12.8588 17.1678 12.8588",
    stroke: "#004B73",
    strokeWidth: 0.833323,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3984 19.0156C22.3984 19.0156 22.6508 21.3143 24.7202 21.3143",
    stroke: "#004B73",
    strokeWidth: 0.833323,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabimage);
export default __webpack_public_path__ + "static/media/labimage.84e37f31983cd53507891a6583a2093e.svg";
export { ForwardRef as ReactComponent };